module.exports = __webpack_public_path__ + "img/cube-multi.c7379bed.svg";